import { render, staticRenderFns } from "./WhatTheyWrite.vue?vue&type=template&id=4b132ae0&scoped=true&"
import script from "./WhatTheyWrite.vue?vue&type=script&lang=js&"
export * from "./WhatTheyWrite.vue?vue&type=script&lang=js&"
import style0 from "./WhatTheyWrite.vue?vue&type=style&index=0&id=4b132ae0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b132ae0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/app/components/base/Btn.vue').default})
